import { useHistory } from 'react-router-dom'
export const Login: React.FC = () => {
	//usehistory hook
	const { push } = useHistory()
	return (
		<section className='component-content'>
			<h1>Login</h1>
			<p>
				Don’t have an account?
				<span>
					<b onClick={() => push('/signup')}> Sign Up</b>
				</span>
			</p>
			<input type='text' placeholder='Email or Username' />
			<input type='password' placeholder='Password' />
			<section className='credentials-util'>
				<div>
					<input type='checkbox' name='my-checkbox' id='opt-in' />
					<label htmlFor='opt-in'>
						<p>Remember me</p>
					</label>
				</div>
				<p>Forget Password?</p>
			</section>
			<button>log in</button>
		</section>
	)
}
